import React from 'react';
import PlanIngredient from "./PlanIngredient/PlanIngredient";
import IngredientSearch from "../../../../IngredientPage/IngredientsList/IngredientSearch/IngredientSearch"

function PlanIngredientsList({ ingredientsArray, handleSearch, handlePair, searchValue }) {
    return (
        <ul className="ing-list-container column">
            <IngredientSearch handleSearch={handleSearch} value={searchValue}></IngredientSearch>
            {
                ingredientsArray?.filter((ingredient) => {

                    return !ingredient.Plan_ID
                }).map(ingredient => (
                    <PlanIngredient key={ingredient.Ingredient_ID.toString()} ingredient={ingredient} handlePair={handlePair} />
                ))
            }
        </ul>
    );
}

export default PlanIngredientsList